export const CARD_TYPE_CNAME = 'CardType';
export const TALL_CAROUSEL_ASPECT_RATIO = '3x4';
export const SHORT_CAROUSEL_ASPECT_RATIO = '4x3';
export const CAROUSEL_ASPECT_RATIO_3X2 = '3x2';
export const CAROUSEL_ASPECT_RATIO_1X1 = '1x1';
export const CAROUSEL_ASPECT_RATIO_16X9 = '16x9';

export const getDisplayName = (Component) =>
    Component.displayName || Component.name || 'Component';
